import React, { Component } from 'react';
import classNames from 'classnames';
import styles from './index.css';
// import PAA from '../../blocks/PhoneAndAddress';

import FooterMobile from '../../blocks/FooterMobile'
import Title from '../../blocks/Title'
import {LangChangeEventContext} from '../../contexts/LangContext';

import AOS from 'aos/dist/aos.js'; 
import 'aos/dist/aos.css';
import MyGallery from '../../blocks/MyGallery'
import IMGS from './imgs.json';

export default class Gallery extends Component {
  state={
    modelOpen: false,
    img    :'',
    isActive: 0
  }  
  componentWillMount(){
   
  }
  componentDidMount(){
    AOS.init({once:true, startEvent: 'DOMContentLoaded'})
  }
  openModal = t => e =>{
    this.setState({
      modelOpen: true,
      isActive: t,
      img:t
    });
  }
  closeModal =()=>{
    this.setState({
      modelOpen: false
    });
  }
  nextActive = num =>{
    this.setState({
      isActive: num
    });
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
            <div className={classNames(styles['galleryBody'])} >  
              <div className={classNames(styles['backgroundImgWrapper'])} 
                data-aos="fade-up" data-aos-offset="50"  data-aos-delay="0"
               >  
                <img alt="" src="/assets/img/g/g-bg.png" className={styles['backgroundImg']} />  
              </div>

              {/* <div className={classNames(styles['modalWrapper'],this.state.modelOpen && styles['is-open'])}>
                <div className={classNames(styles['closeWrapper'])}>
                  <div className={classNames(styles['close'])} onClick={this.closeModal}></div>  
                </div>  
                <div className={classNames(styles['modalImgWrapper'])}>
                  <img alt="modalImage" src={this.state.img} className={styles['modalImg']} /> 
                </div>
              </div> */}
              <MyGallery 
                images      = {IMGS.imgsC.concat(IMGS.imgsR)}
                isActive    = {this.state.isActive}
                nextActive  = {this.nextActive}
                isOpen      = {this.state.modelOpen}
                isClose     = {this.closeModal}
                ADMIN_URL   = {this.props.ADMIN_URL}
              />
              <div className={classNames(styles['contentWrapper'])}>
                <div className={classNames(styles['header'])} data-aos="fade-up" data-aos-offset="50"   data-aos-delay="200">
                  <Title classStyle={styles['titleStyle']} colorStyle="black1"  title={lang.t('galleryHeader')} text={lang.t('gallerySubHeader')}/>
                </div>
                <div className={classNames(styles['content'])}>  
                  <FooterMobile classStyle={styles.footerMobile} />
                  <div className={styles['galleryCenter']}>  
                    {IMGS.imgsC.map( (img,i) => {
                      return(
                        <div className={styles['galleryCenterImgWrapper']} key={i} onClick={this.openModal(i)}  data-aos="fade-up" data-aos-offset="50">  
                          <img alt="" src={this.props.ADMIN_URL+img} className={styles['galleryCenterImg']} />                     
                        </div>  
                      )
                    })}

                  </div>                    
                  <div className={styles['galleryRight']}>
                    <div className={styles['wrapperGalleryRight']}  data-aos="fade-up" data-aos-offset="50"   data-aos-delay="400">
                      {IMGS.imgsR.map( (img,i) => {
                        let k = i+IMGS.imgsC.length;
                        return(
                          <div className={styles['galleryRightImgWrapper']} key={i} onClick={this.openModal(k)}>  
                            <img alt="" src={this.props.ADMIN_URL+img} className={styles['galleryRightImg']} />                     
                          </div>  
                        )
                      })}
                    </div>                    
                  </div>
                  
                </div>            
              </div>
            </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/GalleryMobile/index.js